export default __webpack_public_path__ + "static/media/document-card-tour-background.f4c8198c.svg";